<template>
  <div class="ImageContentBlock">
    <div class="grid">
      <div class="col-1-1">
        <UIHeadingType
          class="mb-xxlg"
          :heading-type="content.seoHeadingtype"
          :title="content.title"
        />
      </div>
      <div
        v-if="isSmall"
        class="col-1-1 small"
      >
        <BaseImage
          :media-object="content?.imageObject"
          :sizes="{ sm: 800, md: 1200, lg: 1600 }"
        />
      </div>
    </div>

    <div
      v-if="!isSmall"
      class="big"
    >
      <BaseImage
        :media-object="content?.imageObject"
        :sizes="{ sm: 800, md: 1200, lg: 1600, xl: 2000 }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { ImageContent } from '@/types/contentblocks'
  import type { ElocusPage, BreadCrumb } from '@tc8l/nuxt-base'

  const props = defineProps<{
    content: ImageContent
    breadCrumb?: BreadCrumb[]
    settings?: ElocusPage
    contentblockIdx?: number
  }>()

  const isSmall = computed(() => props.content?.displayType === 'small')
</script>

<style lang="scss" scoped>
  .ImageComponent {
    overflow: hidden;
    :deep(img) {
      max-height: 90svh;
    }
  }

  .small {
    .ImageComponent {
      border-radius: var(--border-radius-lg);
    }
  }

  .big {
    width: 100%;
    margin: 0;
  }
</style>
